export const IssuingEdgesFilterData = [
    {
        "idFromColumnFilter": "number",
        "id": "number",
    },
    {
        "idFromColumnFilter": "orders",
        "id": "orders",
    },
    {
        "idFromColumnFilter": "date",
        "id": "date",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
]